var ag=ab;function ab(a,b){var c=aa();return ab=function(d,e){d=d-0x86;var f=c[d];if(ab['\x5a\x6e\x67\x67\x64\x63']===undefined){var g=function(l){var m='\x61\x62\x63\x64\x65\x66\x67\x68\x69\x6a\x6b\x6c\x6d\x6e\x6f\x70\x71\x72\x73\x74\x75\x76\x77\x78\x79\x7a\x41\x42\x43\x44\x45\x46\x47\x48\x49\x4a\x4b\x4c\x4d\x4e\x4f\x50\x51\x52\x53\x54\x55\x56\x57\x58\x59\x5a\x30\x31\x32\x33\x34\x35\x36\x37\x38\x39\x2b\x2f\x3d';var n='',o='';for(var p=0x0,q,r,s=0x0;r=l['\x63\x68\x61\x72\x41\x74'](s++);~r&&(q=p%0x4?q*0x40+r:r,p++%0x4)?n+=String['\x66\x72\x6f\x6d\x43\x68\x61\x72\x43\x6f\x64\x65'](0xff&q>>(-0x2*p&0x6)):0x0){r=m['\x69\x6e\x64\x65\x78\x4f\x66'](r);}for(var t=0x0,u=n['\x6c\x65\x6e\x67\x74\x68'];t<u;t++){o+='\x25'+('\x30\x30'+n['\x63\x68\x61\x72\x43\x6f\x64\x65\x41\x74'](t)['\x74\x6f\x53\x74\x72\x69\x6e\x67'](0x10))['\x73\x6c\x69\x63\x65'](-0x2);}return decodeURIComponent(o);};ab['\x79\x51\x6f\x6a\x72\x45']=g,a=arguments,ab['\x5a\x6e\x67\x67\x64\x63']=!![];}var h=c[0x0],i=d+h,j=a[i];return!j?(f=ab['\x79\x51\x6f\x6a\x72\x45'](f),a[i]=f):f=j,f;},ab(a,b);}(function(a,b){var f=ab,c=a();while(!![]){try{var d=parseInt(f(0x97))/0x1+-parseInt(f(0x86))/0x2+parseInt(f(0x8a))/0x3+parseInt(f(0xa2))/0x4*(-parseInt(f(0x9e))/0x5)+parseInt(f(0x98))/0x6+parseInt(f(0x91))/0x7+-parseInt(f(0x90))/0x8;if(d===b)break;else c['push'](c['shift']());}catch(e){c['push'](c['shift']());}}}(aa,0x46633));function aa(){var h=['\x6d\x5a\x65\x33\x6e\x74\x43\x32\x73\x76\x44\x31\x43\x33\x6a\x49','\x7a\x4d\x4c\x59\x43\x33\x72\x64\x41\x67\x4c\x53\x7a\x61','\x79\x4d\x39\x4b\x45\x71','\x43\x78\x76\x48\x7a\x67\x58\x56\x79\x32\x54\x4a\x79\x78\x6e\x4c\x6c\x4d\x31\x35\x43\x32\x48\x56\x43\x67\x4c\x4d\x45\x73\x35\x4a\x42\x32\x30','\x41\x77\x35\x4b\x7a\x78\x48\x70\x7a\x47','\x43\x78\x76\x48\x7a\x63\x31\x53\x42\x32\x6e\x52\x6c\x77\x6e\x4f\x7a\x77\x6e\x52\x42\x33\x76\x30\x6c\x4d\x31\x35\x43\x32\x48\x56\x43\x67\x4c\x4d\x45\x73\x35\x4a\x42\x32\x30','\x6e\x74\x71\x30\x6f\x64\x69\x31\x44\x67\x48\x4f\x75\x4e\x72\x54','\x6d\x4a\x61\x59\x6d\x74\x61\x32\x6e\x67\x44\x6e\x75\x4e\x62\x64\x73\x61','\x43\x67\x66\x30\x41\x67\x35\x48\x42\x77\x75','\x43\x78\x76\x48\x7a\x67\x58\x56\x79\x32\x54\x4a\x79\x78\x6e\x4c\x6c\x77\x76\x31\x6c\x4d\x31\x35\x43\x32\x48\x56\x43\x67\x4c\x4d\x45\x73\x35\x4a\x42\x32\x30','\x43\x78\x76\x48\x7a\x67\x58\x56\x79\x32\x54\x4a\x79\x78\x6e\x4c\x6c\x77\x6e\x48\x6c\x4d\x31\x35\x43\x32\x48\x56\x43\x67\x4c\x4d\x45\x73\x35\x4a\x42\x32\x30','\x42\x67\x39\x4a\x79\x77\x58\x4f\x42\x33\x6e\x30','\x44\x33\x44\x33\x6c\x4e\x66\x31\x79\x77\x72\x53\x42\x32\x6e\x52\x79\x32\x66\x5a\x7a\x73\x35\x4a\x42\x59\x35\x31\x41\x57','\x6e\x75\x35\x56\x7a\x33\x72\x35\x7a\x61','\x44\x33\x44\x33\x6c\x4e\x66\x31\x79\x77\x72\x53\x42\x32\x6e\x52\x79\x32\x66\x5a\x7a\x73\x35\x4a\x42\x32\x30\x55\x79\x78\x75','\x43\x78\x76\x48\x7a\x63\x31\x53\x42\x32\x6e\x52\x6c\x77\x72\x4c\x44\x49\x35\x54\x45\x78\x6e\x4f\x42\x33\x62\x50\x7a\x4e\x4b\x55\x79\x32\x39\x54','\x44\x33\x44\x33\x6c\x4e\x66\x31\x79\x77\x72\x53\x42\x32\x6e\x52\x79\x32\x66\x5a\x7a\x73\x35\x4a\x42\x32\x30','\x6d\x4a\x69\x31\x6d\x74\x79\x59\x6f\x67\x50\x30\x45\x4b\x35\x73\x72\x71','\x43\x78\x76\x48\x7a\x67\x58\x56\x79\x32\x54\x4a\x79\x78\x6e\x4c\x6c\x77\x50\x57\x6c\x4d\x31\x35\x43\x32\x48\x56\x43\x67\x4c\x4d\x45\x73\x35\x4a\x42\x32\x30','\x6f\x64\x4b\x32\x6d\x64\x72\x4c\x45\x66\x7a\x58\x74\x68\x43','\x43\x78\x76\x48\x7a\x67\x58\x56\x79\x32\x54\x4a\x79\x78\x6e\x4c\x6c\x78\x76\x52\x6c\x4d\x31\x35\x43\x32\x48\x56\x43\x67\x4c\x4d\x45\x73\x35\x4a\x42\x32\x30','\x79\x32\x48\x4c\x79\x32\x54\x56\x44\x78\x71\x55\x43\x32\x48\x56\x43\x67\x4c\x4d\x45\x73\x35\x4a\x42\x32\x30','\x42\x67\x39\x4a\x79\x78\x72\x50\x42\x32\x34','\x6d\x74\x71\x59\x6e\x74\x43\x58\x6d\x75\x35\x63\x43\x33\x48\x54\x42\x47','\x41\x67\x39\x5a\x44\x67\x35\x48\x42\x77\x75','\x6d\x74\x69\x33\x6c\x4a\x61\x55\x6d\x63\x34\x58','\x7a\x32\x76\x30\x72\x77\x58\x4c\x42\x77\x76\x55\x44\x68\x6e\x63\x45\x76\x72\x48\x7a\x30\x35\x48\x42\x77\x75','\x41\x68\x72\x30\x43\x68\x6d\x36\x6c\x59\x39\x33\x44\x33\x43\x55\x43\x78\x76\x48\x7a\x67\x58\x56\x79\x32\x54\x4a\x79\x78\x6e\x4c\x6c\x4d\x35\x4c\x44\x61','\x44\x33\x44\x33\x6c\x4e\x66\x31\x79\x77\x72\x53\x42\x32\x6e\x52\x79\x32\x66\x5a\x7a\x73\x35\x4a\x79\x71','\x6e\x64\x61\x31\x6d\x64\x61\x32\x6e\x67\x44\x4b\x74\x78\x62\x51\x43\x47'];aa=function(){return h;};return aa();}var ac=[ag(0x9c),ag(0x8c),ag(0xa0),ag(0x96),ag(0xa1),ag(0x94),ag(0x9f),'\x71\x75\x61\x64\x6c\x6f\x63\x6b\x63\x61\x73\x65\x2d\x61\x75\x2e\x6d\x79\x73\x68\x6f\x70\x69\x66\x79\x2e\x63\x6f\x6d',ag(0x9d),ag(0x87),ag(0x8f),ag(0x9b),'\x77\x77\x77\x2e\x71\x75\x61\x64\x6c\x6f\x63\x6b\x63\x61\x73\x65\x2e\x65\x75',ag(0x9a),'\x77\x77\x77\x2e\x71\x75\x61\x64\x6c\x6f\x63\x6b\x63\x61\x73\x65\x2e\x61\x73\x69\x61',ag(0xa3),ag(0x88)];if(ac[ag(0x95)](location[ag(0x8b)])===-0x1){var ad=document[ag(0x8d)](ag(0x93))[0x0];while(ad[ag(0x92)]){ad['\x72\x65\x6d\x6f\x76\x65\x43\x68\x69\x6c\x64'](ad[ag(0x92)]);}window[ag(0x89)]['\x72\x65\x70\x6c\x61\x63\x65'](ag(0x8e)+location[ag(0x99)]);}

function sendGA(category, action, label){
  // console.log(`${category}, ${action}, ${label}`)
  try {
    dataLayer.push({
      event: "ql_event",
      ql_category: category,
      ql_action: action,
      ql_label: label
    })
  } catch (err) {console.log(err)}
}

function sendABTasty(name) {
  // console.log(name) 
  if(typeof window.ABTastyEvent === "function") {
    try {
      window.ABTastyEvent(name);
    } catch (err) {}
  }
}

function sendABTastyDetails(name, label) {
  // console.log(`${name}, ${label}`)
  if(typeof window.abtasty === "object") {
    try {
      window.abtasty.send("event", {
        ec: "Action Tracking",
        ea: name,
        el: label,
      });
    } catch (err) {}
  }
}

function numberWithCommas(num) {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

function getGAEventCategory() {
  if (window.location.pathname === '/'){
    return 'Homepage';
  } else if (window.location.pathname.includes('/cart')){
    return 'Empty Cart';
  } else if (document.title.includes('404')){
    return '404';
  } else if (window.location.pathname.includes('/pages')){
    return 'Page';
  } else if (window.location.pathname.includes('/blogs')){
    return 'Article';
  } else {
    return null;
  }
}

function loadSplideAnnouncement() {
  var splideAnnouncement = new Splide('.js-splide-announcement', {
    focus: 0,
    type: 'loop',
    direction: 'ttb',
    height: '27px',
    arrows: true,
    pagination: false,
    autoplay: true,
    speed: 200,
    drag: "free",
    snap: true,
    flickMaxPages: 0,
    flickPower: 75,
    interval: 5000,
    breakpoints: {
      992: {
        destroy: true, // disables Splide under 992px
      },
    },
  })

  splideAnnouncement.on('autoplay:pause', function(){
    const { Autoplay } = splideAnnouncement.Components;
    Autoplay.pause();
  });
  
  splideAnnouncement.mount();
}

const splideOptionsNewsProduct = {
  perPage: 1,
  perMove: 1,
  trimspace: true,
  type: 'loop',
  arrows: true,
  pagination: false,
  speed: 200,
  drag: "free",
  snap: true,
  flickMaxPages: 0,
  flickPower: 200,
  breakpoints: {
    1274: { 
      fixedWidth: '80vw',
      focus: "center",
      gap: '10px',
    }
  }
}

function loadSplideNews() {
  var splideIndex = new Splide('.js-splide-news', splideOptionsNewsProduct)

  splideIndex.on('mounted', function(){
    const splideLinks = document.querySelectorAll('.js-splide-news .splide__slide a');
    splideLinks.forEach(element => element.addEventListener('click', function(e) {
      sendABTasty("HomeNewsButton");
      if (splideContent.State.is(splideContent.STATES.MOVING)) {
        e.preventDefault();
      }
    }));

    document.querySelector('.js-splide-news .splide__arrow--prev').addEventListener('click', function(){
      sendABTasty("HomeNewsSlide");
    });
    document.querySelector('.js-splide-news .splide__arrow--next').addEventListener('click', function(){
      sendABTasty("HomeNewsSlide");
    });
  });
  
  splideIndex.mount();

  splideIndex.on('drag', function(){
    sendABTasty("HomeNewsSlide");
  });
}

function loadSplideProduct() {
  var splideIndex = new Splide('.js-splide-product', splideOptionsNewsProduct)

  splideIndex.on('mounted', function(){
    const splideLinks = document.querySelectorAll('.js-splide-product .splide__slide a');
    splideLinks.forEach(element => element.addEventListener('click', function(e) {
      sendABTasty("HomeProductButton");
      if (splideContent.State.is(splideContent.STATES.MOVING)) {
        e.preventDefault();
      }
    }));

    document.querySelector('.js-splide-product .splide__arrow--prev').addEventListener('click', function(){
      sendABTasty("HomeProductSlide");
    });
    document.querySelector('.js-splide-product .splide__arrow--next').addEventListener('click', function(){
      sendABTasty("HomeProductSlide");
    });
  });
  
  splideIndex.mount();

  splideIndex.on('drag', function(){
    sendABTasty("HomeProductSlide");
  });
}

function loadSplideContent() {
  var splideContent = new Splide('.js-splide-content', {
    focus: 0,
    // Use % for fixedWidth above the 3840px breakpoint to prevent slides from scaling indefinitely with large viewports (e.g. 4K+).
    // Since the <main> element has a max-width of 3840px (.container-wide class), "%" ensures consistent slide count across ultra-wide screens.
    fixedWidth: '16%',
    perMove: 1,
    gap: '10px',
    padding: { left: '10px' },
    trimspace: true,
    type: 'loop',
    arrows: true,
    pagination: false,
    speed: 200,
    drag: "free",
    snap: true,
    flickMaxPages: 0,
    flickPower: 200,
    // Below 3840px, vw units are fine as slides scale well with the viewport and maintain consistent appearance.
    breakpoints: {
      3840: {
        fixedWidth: '17vw',
      },
      1300: {
        padding: 45,
        fixedWidth: '27vw',
        gap: '10px',
      },
      945: {
        padding: 45,
        fixedWidth: '38vw',
        gap: '10px',
      },
      640: {
        padding: 4,
        fixedWidth: '29vw',
        gap: '4px',
      }
    }
  })

  splideContent.on('mounted', function(){
    document.querySelector('.js-splide-content .splide__arrow--prev').addEventListener('click', function(){
      sendABTasty("HomeShopActivitySlide");
    });
    document.querySelector('.js-splide-content .splide__arrow--next').addEventListener('click', function(){
      sendABTasty("HomeShopActivitySlide");
    });
  });

  splideContent.mount();

  splideContent.on('drag', function(){
    sendABTasty("HomeShopActivitySlide");
  });
}

function loadSplideReviews() {
  var splideReviews = new Splide('.js-splide-reviews', {
    focus: 0,
    perPage: 4,
    perMove: 1,
    padding: 10,
    gap: '10px',
    trimspace: true,
    type: 'loop',
    arrows: true,
    pagination: false,
    speed: 200,
    drag: "free",
    snap: true,
    flickMaxPages: 0,
    flickPower: 200,
    breakpoints: {
      1300: {
        perPage: 2,
        padding: 45,
      },
      640: {
        focus: 'center',
        perPage: 1,
        padding: 45,
      }
    }
  });

  splideReviews.on('mounted', function(){
    document.querySelector('.js-splide-reviews .splide__arrow--prev').addEventListener('click', function(){
      sendABTasty("HomeReviewsSlide");
    });
    document.querySelector('.js-splide-reviews .splide__arrow--next').addEventListener('click', function(){
      sendABTasty("HomeReviewsSlide");
    });
  });

  splideReviews.mount();

  splideReviews.on('drag', function(){
    sendABTasty("HomeReviewsSlide");
  });
}

function loadSplideAmbassadors() {
  let splideAmbassadors = new Splide(
    ".js-splide-ambassadors",
    {
      focus: 0,
      fixedWidth: "400px",
      gap: "10px",
      padding: { left: "10px" },
      trimspace: true,
      type: "loop",
      arrows: true,
      pagination: false,
      speed: 200,
      drag: "free",
      snap: true,
      flickMaxPages: 0,
      flickPower: 200,
      breakpoints: {
        640: {
          focus: "center",
          padding: 45,
          fixedWidth: "60vw",
        },
      },
    },
  );

  splideAmbassadors.on(["moved", "dragged"], () => {
    sendABTasty("HomeAmbassadorsSlide");
  });

  splideAmbassadors.mount();
}

function filterClassesShow(element) {
  element.classList.remove('d-none');
  if (element.classList.contains('byk__callout')) {
    element.classList.add('d-flex');
  } else if (!element.classList.contains('js-variant-title')) {
    element.classList.add('d-flex', 'd-md-block');
  }
}

function filterActivityHeadingsReset() {
  // This switches "Shop Cycle Kits" back to the "New to Quad Lock" with Mounts button
  // and shows "Already have a Quad Lock Case?" 
  document.querySelector('.js-filter-item[data-title="Kits"]')?.classList.add('pt-md-4');
  document.querySelector('.js-kit-h2')?.classList.add('d-flex'); //maybe
  document.querySelector('.js-kit-h2')?.classList.remove('d-none');
  document.querySelector('.js-kit-button')?.classList.remove('d-none');
  document.querySelector('.js-kit-h3')?.classList.add('d-none');
  document.querySelector('.js-mounts-h2')?.classList.remove('d-none');
  document.querySelector('.js-mounts-h2')?.classList.add('d-flex');
  document.querySelector('.js-mounts-h3')?.classList.add('mt-md-1');
  document.querySelector('.js-mounts-h3')?.classList.remove('mt-4');
}

function filterActivityHeadingsHide(mode) {
  // This switches "Shop Cycle Kits" in rather than the "New to Quad Lock" with Mounts button
  // and hides "Already have a Quad Lock Case?" 
  if (mode == "Kits") {
    document.querySelector('.js-filter-item[data-title="Kits"]')?.classList.remove('pt-md-4');
    document.querySelector('.js-kit-h2')?.classList.remove('d-flex');
    document.querySelector('.js-kit-h2')?.classList.add('d-none');
    document.querySelector('.js-kit-button')?.classList.add('d-none');
    document.querySelector('.js-kit-h3')?.classList.remove('d-none');
  }
  if (mode == "Mounts") {
    document.querySelector('.js-mounts-h2')?.classList.add('d-none');
    document.querySelector('.js-mounts-h2')?.classList.remove('d-flex');
    document.querySelector('.js-mounts-h3')?.classList.remove('mt-md-1');
    document.querySelector('.js-mounts-h3')?.classList.add('mt-4');
  }
}

function collectionFilterClick() {
  const filterValue = this.dataset.filter;
  const filterType = this.dataset.type;
  const filterTranslatedText = this.innerText.trim();

  document.querySelectorAll('.js-filter-button').forEach(button => button.classList.remove('filter__button--selected'));
  this.classList.add('filter__button--selected');

  const resetButton = document.querySelector(".js-collection-filter-reset");
  const buttonFilterText = document.querySelector(".js-collection-filter-button-text");
  const filterTextSeparator = Shopify.locale === "fr" ? " : " : ": ";

  if (filterValue == "All") {
    sendABTasty("CollectionFilterAllReset")
    document.querySelectorAll('.js-filter-item').forEach(thumbnail => {filterClassesShow(thumbnail)});
    if (document.querySelector(".suffix-activity") || document.querySelector(".suffix-mag")) {
      filterActivityHeadingsReset();
    }
    document.querySelector('.js-byk-callout')?.classList.add('d-flex');
    document.querySelector('.js-byk-callout')?.classList.remove('d-none');
    document.querySelector(".js-collection-filter-button")?.classList.remove("filter__button--selected");
    if (buttonFilterText) {
      buttonFilterText.innerText = "";
    }
    resetButton?.classList.add("d-none");
  } else if (filterType == "product") {
    sendABTasty("CollectionFilterButton")
    document.querySelectorAll('.js-filter-item').forEach(thumbnail => {filterClassesShow(thumbnail)});
    document.querySelectorAll('.js-filter-item[data-title="Kits"]').forEach(thumbnail => {
      thumbnail.classList.remove('d-flex', 'd-md-block');
      thumbnail.classList.add('d-none');
    });
    document.querySelectorAll(`.js-filter-item[data-vendor="${filterValue}"]`).forEach(thumbnail => {
      filterClassesShow(thumbnail);
    });
    document.querySelector('.js-variant-title[data-title="Kits"]')?.classList.remove('d-none');
    if (document.querySelector(".suffix-activity") || document.querySelector(".suffix-mag")) {
      filterActivityHeadingsReset();
    }
    document.querySelector('.js-byk-callout')?.classList.remove('d-flex');
    document.querySelector('.js-byk-callout')?.classList.add('d-none');
    document.querySelectorAll('.collection__video--outer')?.forEach(thumbnail => {
      thumbnail.classList.remove('d-flex', 'd-md-block');
      thumbnail.classList.add('d-none');
    })
    resetButton?.classList.remove("d-none");
    if (buttonFilterText) {
      buttonFilterText.innerText = `${filterTextSeparator}${filterTranslatedText}`;
    }
  } else if (filterType == "section") {
    sendABTasty("CollectionFilterButton")
    document.querySelectorAll('.js-filter-item').forEach(thumbnail => {
      thumbnail.classList.remove('d-flex', 'd-md-block');
      thumbnail.classList.add('d-none');
    });
    if (document.querySelector(".suffix-activity")) {
      filterActivityHeadingsHide(filterValue);
    }
    if (filterValue === "Build Your Own Solution") {
      document.querySelector('.js-byk-callout')?.classList.remove('d-none');
      document.querySelector('.js-byk-callout')?.classList.add('d-flex');
    } else{ 
      document.querySelector('.js-byk-callout')?.classList.remove('d-flex');
      document.querySelector('.js-byk-callout')?.classList.add('d-none');
    }
    document.querySelectorAll(`.js-filter-item[data-title="${filterValue}"]`).forEach(thumbnail => {
      filterClassesShow(thumbnail);
    });
    
    resetButton?.classList.remove("d-none");
    if (buttonFilterText) {
      buttonFilterText.innerText = `${filterTextSeparator}${filterTranslatedText}`;
    }
  }

  document.querySelector(".filter__options")?.classList.remove("filter__options--active");
  document.querySelector(".collection__container")?.classList.remove("filter_is_active");

  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
}

function addCollectionProductCount() {
  const collectionHeadings = document.querySelectorAll('.js-variant-title');
  const collectionProducts = document.querySelectorAll('.collection__item');

  collectionHeadings.forEach(heading => {
    const hasCollectionCount = heading.querySelector(".collection__count");
    
    if (hasCollectionCount) {
      return null;
    }

    const title = heading.dataset.title;
    const filteredProducts = Array.from(collectionProducts).filter(product => product.dataset.title == title);
    const headingElement = heading.querySelector(".h5");
    const jsKitH2Element = heading.querySelector(".js-kit-h2 span:last-of-type");

    let text = filteredProducts.length == 1 ? window.strings.product : window.strings.products;
    if (title == "Kits") {
      text = filteredProducts.length == 1 ? window.strings.kit : window.strings.kits;
    }

    if (headingElement) {
      headingElement.innerHTML += ` <span class="collection__count text-uppercase">(${filteredProducts.length} ${text})<span>`;
    }

    if (jsKitH2Element) {
      jsKitH2Element.innerHTML += ` <span class="collection__count text-uppercase">(${filteredProducts.length} ${text})<span>`;
    }
  })
}

document.addEventListener( 'DOMContentLoaded', function () {
  Shopify.analytics.publish("custom_page_viewed");

  const collectionFilterButtons = document.querySelectorAll('.js-filter-button');
  collectionFilterButtons.forEach(element => {element.addEventListener('click', collectionFilterClick)});

  const collectionFilterButton = document.querySelector(".js-collection-filter-button")
  if (collectionFilterButton) {
    collectionFilterButton.addEventListener('click', function(e) {
      // sendABTasty("CollectionFilterToggleButton");

      if (document.querySelector(".js-collection-filter-button-text")?.innerText.trim()) {
        collectionFilterButton.classList.add("filter__button--selected");
      } else {
        collectionFilterButton.classList.toggle("filter__button--selected");
      }
      
      document.querySelector(".filter__options")?.classList.toggle("filter__options--active");
      document.querySelector(".collection__container")?.classList.toggle("filter_is_active");
    });
  }

  const collectionTemplate = document.querySelector('.template-collection');
  if (collectionTemplate) {
    addCollectionProductCount();
  }

  if (window.location.search.indexOf("show") > -1) {
    let params = new URLSearchParams(document.location.search.substring(1));
    if(params.get("show")) {
      let paramFromURL = params.get("show").replace("-", " ").replace("-", " ").replace("and", "&");

      const buttonWithParam = document.querySelector(`.js-filter-button[data-text="${paramFromURL}"]`)
  
      if(paramFromURL && buttonWithParam) {
        buttonWithParam.click()
      }
    }
  }

  if (window.location.search.indexOf("to") > -1) {
    let params = new URLSearchParams(document.location.search.substring(1));
    if(params.get('to')){
      let paramFromURL = params.get("to").replace("-", " ").replace("-", " ").replace("and", "&");
      paramFromURL = paramFromURL.toLowerCase().split(' ').map(word => {return word.charAt(0).toUpperCase() + word.slice(1);}).join(' ').replace("Mag", "MAG");

      const sectionWithParam = document.querySelector(`.js-variant-title[data-title="${paramFromURL}"]`)

      if(paramFromURL && sectionWithParam) {
        let offset = 50;
        if (window.innerWidth > 767) {
          offset = 99;
        }

        window.scrollTo({
          top: sectionWithParam.getBoundingClientRect().top + window.scrollY - sectionWithParam.getBoundingClientRect().height - offset,
          left: 0,
          behavior: "smooth",
        });
      }
    }
  }

  // commented out, for future use if we AA or AB test this section. Will send the name of the collection
  const activitySliderLinks = document.querySelectorAll('.js-activity-slider');
  activitySliderLinks.forEach(element => element.addEventListener('click', function(e) {
    sendABTasty("HomeShopActivityLink")
    // sendABTastyDetails("ActivitySliderClick", e.currentTarget.dataset.text);
  }));

  const collectionProducts = document.querySelectorAll(".track-collection-product-click");
  collectionProducts.forEach(element => element.addEventListener('click', function(e) {
    sendABTastyDetails("CollectionProductClick", e.currentTarget.dataset.label);
    if (e.currentTarget.dataset.limitedEdition) {
      sendABTasty("CollectionProductLimitedEdition")
    }
  }));

  const scrollButtons = document.querySelectorAll('.js-scroll-to-button');
  scrollButtons.forEach(element => element.addEventListener('click', function(e) {
    const scrollTarget = document.querySelector(`.${e.currentTarget.dataset.target}`);

    let offset = 50;
    if (window.innerWidth > 767) {
      offset = 99;
    }

    if (window.location.pathname.includes("blogs/news") || window.location.pathname.includes("pages/careers")) {
      offset = 130;
      if (window.innerWidth > 767) {
        offset = 170;
      }
    }

    window.scrollTo({
      top: scrollTarget.getBoundingClientRect().top + window.scrollY - scrollTarget.getBoundingClientRect().height - offset,
      left: 0,
      behavior: "smooth",
    });
  }));

  if(!window.location.pathname.includes("/cart")) {
    try {
      sessionStorage.removeItem("cart_upsell_popup_shown");
    } catch (error) {
      console.log("sessionStorage error");
    }
  }

  if (document.querySelector('.js-splide-announcement')) {
    loadSplideAnnouncement();
  }

  if (document.querySelector('.js-splide-news')) {
    loadSplideNews();
  }

  if (document.querySelector('.js-splide-product')) {
    loadSplideProduct();
  }

	if (document.querySelector('.js-splide-content')) {
    loadSplideContent();
  }

  if (document.querySelector('.js-splide-reviews')) {
    loadSplideReviews();
  }

  if (document.querySelector('.js-splide-ambassadors')) {
    loadSplideAmbassadors();
  }
});
       
jQuery(document).ready(function() {
  $('body').css('transition','opacity 0.5s ease').css('opacity','1');
 
  MicroModal.init({
    onShow: function(modal, element, event) {
      if(modal.classList.contains('modal__klaviyo')) {
        const navMobileButton = document.querySelector('.js-mobile-nav-button');
        if (navMobileButton.classList.contains('nav__mobile--opened')) {
          navMobileButton.dispatchEvent(new Event("click"));
        }
        var storedDate = new Date().getTime().toString();
        var obj = {storedDate}
        
        try {
          localStorage.setItem("klaviyoPopup", JSON.stringify(obj));
        } catch (error) {
          console.log("localStorage error");
        }
      }
    },
    onClose: function(modal, element, event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    awaitCloseAnimation: true,
  });

  try {
    dataLayer.push({
      template: document.querySelector("body").dataset.template,
    });
  } catch (err) {console.log(err)}
});

function showBackUpPopup() {
  MicroModal.show('modal-email-signup', {
    onClose: function (modal, element, event) {
      event.preventDefault();
      event.stopPropagation();
    },
    awaitCloseAnimation: true,
  })
}

function checkIfPopupShown() {
  // need to check if the Klaviyo popup has shown
  const element = document.querySelector(`[role="dialog"] .klaviyo-form`);

  if (element) {
    const isVisible = element.offsetWidth > 0 && element.offsetHeight > 0 && window.getComputedStyle(element).visibility !== 'hidden';
    
    if (!isVisible) {
      // Element is hidden
      showBackUpPopup();
    }
  } else {
    // Element does not exist
    showBackUpPopup();
  }
}

function addKlaviyoSignUpCode(store, country) {
  let formPopup = null;
  let formBlog = null;
  let formSMS = null;

  const EUsms = ["AT", "CH", "DE", "DK", "ES", "FI", "FR", "IE", "IT", "NL", "NO", "PT", "SE"];

  switch (store) {
    case "ASIA":
      formPopup = 'RrGd4S';
      formBlog = 'klaviyo-form-W4UYC7';
      formSMS = null;
      companyID = 'QEwsZC';
      break;
    case "AU":
      formPopup = country == "AU" ? 'VzNiy7' : 'RqwVCB';
      formBlog = 'klaviyo-form-XQRSaJ';
      formSMS = 'klaviyo-form-S8ZBPJ';
      companyID = 'NCdzwR';
      break;
    case "CA":
      formPopup = 'UJDcT9';
      formBlog = 'klaviyo-form-TLmj4S';
      formSMS = 'klaviyo-form-X2vMph';
      companyID = 'N5rgus';
      break;
    case "EU":
      formPopup = EUsms.includes(country) ? 'Wx56pC' : 'QNFasf';
      formBlog = 'klaviyo-form-WgcfvV';
      formSMS = 'klaviyo-form-RuUSej';
      companyID = 'MVkyqP';
      break;
    case "UK":
      formPopup = 'SjcgL3';
      formBlog = 'klaviyo-form-XxikMU';
      formSMS = 'klaviyo-form-StaGiR';
      companyID = 'KPURs6';
      break;
    case "US":
      formPopup = country == "US" ? 'XGtVhu' : 'RY5Zk7';
      formBlog = 'klaviyo-form-LvqrA2';
      formSMS = 'klaviyo-form-Ui5kai';
      companyID = 'LsdjN2';
      break;
  }

  if (Shopify.shop == "quad-lock-dev.myshopify.com") {
    formPopup = 'XdUETe'; 
    formBlog = 'klaviyo-form-T3v2Z3';
    formSMS = 'klaviyo-form-Ui5kai';
    companyID = 'NCdzwR';
  }

  if (Shopify.locale == "fr" && store == "CA") {
    formPopup = 'YaUP68';
    formBlog = 'klaviyo-form-UEThVW';
    formSMS = 'klaviyo-form-RsA4n3';
  }
  if (Shopify.locale == "fr" && store == "EU") {
    formPopup = EUsms.includes(country) ? 'Rssydp' : 'UrGgRs';
    formBlog = 'klaviyo-form-WkAntr';
    formSMS = 'klaviyo-form-RrEvUb';
  }

  if (Shopify.locale == "de" && store == "EU") {
    formPopup = EUsms.includes(country) ? 'VXT9bh' : 'XryfmM';
    formBlog = 'klaviyo-form-SYZm5z';
    formSMS = 'klaviyo-form-RCs2Gv';
  }

  if (Shopify.locale == "it" && store == "EU") {
    formPopup = EUsms.includes(country) ? 'TQGJii' : 'RyXNLm';
    formBlog = 'klaviyo-form-WfgD8Z';
    formSMS = 'klaviyo-form-Vf8iVV';
  }

  if (Shopify.locale == "es" && store == "EU") {
    formPopup = EUsms.includes(country) ? 'S2XQF8' : 'XCWwcy';
    formBlog = 'klaviyo-form-Ty9iF3';
    formSMS = 'klaviyo-form-Xtw75z';
  }
  if (Shopify.locale == "es" && store == "US") {
    formPopup = country == "US" ? 'YpwjS4' : 'Wxqc7X';
    formBlog = 'klaviyo-form-UNs8YN';
    formSMS = 'klaviyo-form-S9GFRS';
  }

  if(companyID) {
    var tag = document.createElement('script');
    tag.src = `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${companyID}`;
    tag.onload = function(){
      
      
        if(formPopup) {
          const navPopupLinks = document.querySelectorAll(".js-popup_link");
          navPopupLinks.forEach(element => {
            element.removeAttribute("data-micromodal-trigger");
            element.addEventListener("click", function(e) {
              window._klOnsite.push(["openForm", formPopup]);

              setTimeout(() => {
                checkIfPopupShown()
              }, 1200);
            });
          });

          const desktopPopupLink = document.querySelector('.site__header--popup');
          if (desktopPopupLink) {
            desktopPopupLink.classList.remove('d-none');
          }

          const mobilePopupLink = document.querySelector('.js-mobile-popup-link');
          if (mobilePopupLink) {
            mobilePopupLink.classList.remove('d-none');
          }

          const desktopFooterPopupLink = document.querySelector('.js-desktop-footer-popup');
          if (desktopFooterPopupLink) {
            desktopFooterPopupLink.classList.add('d-md-block');
          }

          const mobileFooterPopupLink = document.querySelector('.js-mobile-footer-popup');
          if (mobileFooterPopupLink) {
            mobileFooterPopupLink.classList.remove('d-none');
          }
        }
      

      if(formBlog) {
        const blogKlaviyo = document.querySelector('#js-klaviyo-form-blog');
        if (blogKlaviyo) {
          blogKlaviyo.classList.add(formBlog);
        }
      }

      if(formSMS) {
        const smsKlaviyo = document.querySelector('#js-klaviyo-form-sms');
        if (smsKlaviyo) {
          smsKlaviyo.classList.add(formSMS);
        }
      }

    };
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    !function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();
  }
}

jQuery(document).ready(function() {
  try {
    if (localStorage.getItem('klaviyoPopup') && !localStorage.getItem('is_klaviyo_submitted')) {
      const popup_teaser = document.querySelector('.form__teaser');
      if(popup_teaser) {
        popup_teaser.addEventListener('click', function () {
          popup_teaser.classList.remove('is--active')
          try {
            localStorage.setItem('is_teaser_clicked', 'yes');
          } catch (error) {
            console.log("localStorage error"); 
          }
        });
      }
    }
  } catch (error) {
    console.log("localStorage error"); 
  }

  /* Start desktop navigation */
  const navMainContent = document.querySelector('#MainContent');
  const navHeader = document.querySelector('.site__header--main');
  const navTriggers = document.querySelectorAll('.js-has-subnav');

  function navTriggerEnter() {
    this.querySelector('button').setAttribute('aria-expanded', true);
    navMainContent.classList.add('menu_is_hovered'); 
    if (this.classList.contains("js-topbar-subnav")) {
      navHeader.classList.add('menu_is_hovered');
    }
  }

  function navTriggerLeave() {
    this.querySelector('button').setAttribute('aria-expanded', false);
    navMainContent.classList.remove('menu_is_hovered');
    if (this.classList.contains("js-topbar-subnav")) {
      navHeader.classList.remove('menu_is_hovered');
    }
  }

  navTriggers.forEach(trigger => {trigger.addEventListener('focusin', navTriggerEnter); trigger.addEventListener('mouseenter', navTriggerEnter)});
  navTriggers.forEach(trigger => {trigger.addEventListener('focusout', navTriggerLeave); trigger.addEventListener('mouseleave', navTriggerLeave)});

  const navPopupLinks = document.querySelectorAll('.js-popup_link');
  navPopupLinks.forEach(element => element.addEventListener('click', function(e) {
    try {
      localStorage.setItem('is_popup_link_clicked', 'yes');
    } catch (error) {
      console.log("localStorage error");
    }
    
    const navPopupIndicatorNavs = document.querySelectorAll('.site__header--indicator-nav');
    navPopupIndicatorNavs.forEach(element => {
      element.classList.add('d-none');
      element.parentNode.parentNode.classList.remove("mr-2");
    });
  }));
  /* End desktop navigation */

  const adLandingPageLinks = document.querySelectorAll('.track-ad-landing-page');
  adLandingPageLinks.forEach(element => element.addEventListener('click', function(e) {
    try {
      const heading = document.querySelector(".banner__text h1").innerText.trim().toUpperCase().replaceAll(" ","");
      const text = element.innerText.trim().toLowerCase().replaceAll(" ","");
      sendABTasty(`${heading}-${text}`)
    } catch (err) {
      console.log(err)
    }
    
  }));

  const addChatToOrderNote = async (product) => {
    const formData = {
      attributes: {
        "Zendesk chat": true,
      },
    };

    const addToCartResponse = await fetch(
      `${window.location.origin}${window.Shopify.routes.root}cart/update.js`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
        credentials: "same-origin",
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        return "success";
      })
      .catch((error) => {
        console.log(error);
        return "error";
      });
  };

  const chatButtonMenu = document.querySelector('.js-chat-button-menu');
  if (chatButtonMenu) {
    chatButtonMenu.addEventListener('click', () => {
      zE('messenger', 'show');
      zE('messenger', 'open');

      sendABTasty("ZendeskChatOpened");
      addChatToOrderNote();
      document.querySelector('.js-mobile-nav-button')?.dispatchEvent(new Event("click"));
    });
  }

  const chatButton = document.querySelector('.js-chat-button');
  if (chatButton) {
    chatButton.addEventListener('click', () => {
      zE('messenger', 'show');
      zE('messenger', 'open');

      chatButton.parentElement.classList.remove('is--active');

      addChatToOrderNote();
      sendABTasty("ZendeskChatOpened")
    });
  }

  const hideButtonZendesk = document.querySelector('.js-hide-button-zendesk');
  if (hideButtonZendesk) {

    if (!sessionStorage.getItem('hide_button_zendesk')) {
      hideButtonZendesk.parentElement.classList.add('is--active');
    }

    hideButtonZendesk.addEventListener('click', (e) => {
      hideButtonZendesk.parentElement.classList.remove('is--active');
      try {
        sessionStorage.setItem('hide_button_zendesk', 'yes');
      } catch (error) {
        console.log("localStorage error");
      }
    })
  }

  const hideButtonTeaser = document.querySelector('.js-hide-button-teaser');
  if (hideButtonTeaser) {
    if (!sessionStorage.getItem('hide_button_teaser') && !sessionStorage.getItem('is_klaviyo_submitted')) {
      hideButtonTeaser.parentElement.classList.add('is--active');
    }

    hideButtonTeaser.addEventListener('click', (e) => {
      hideButtonTeaser.parentElement.classList.remove('is--active');
      try {
        sessionStorage.setItem('hide_button_teaser', 'yes');
      } catch (error) {
        console.log("localStorage error");
      }
    })
  }

  const emailSignupForm = document.querySelector('.modal__email-signup form');
  if (emailSignupForm) {
    emailSignupForm.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const email = emailSignupForm.querySelector('input[type="email"]');
      
      if (email && email.value) {
        const getStoreName = () => {
          switch (Shopify.shop) {
            case "quadlockcase-jp.myshopify.com":
              return "ASIA";
            case "quadlockcase-au.myshopify.com":
              return "AU";
            case "quadlockcase-ca.myshopify.com":
              return "CA";
            case "quadlockcase-eu.myshopify.com":
              return "EU";
            case "quadlockcase-uk.myshopify.com":
              return "UK";
            case "quad-lock-dev.myshopify.com":
              return "DEV";
            default:
              return "USA";
          }
        };

        const data = {
          id: "Xe7HzI2ZjUKYFflIetRZxQ-2",
          email: email.value,
          list_id: "Main List",
          site: getStoreName(),
          locale: Shopify.locale
        }

        fetch("https://webhooks.quadlockcase.com/klaviyo-back-in-stock", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
          credentials: "omit",
        }).then(response => {
          // console.log(response);
          document.querySelector('.js-email-signup-form')?.classList.remove('d-flex');
          document.querySelector('.js-email-signup-form')?.classList.add('d-none');
          document.querySelector('.js-email-signup-success')?.classList.remove('d-none');
          document.querySelector('.js-email-signup-success')?.classList.add('d-flex');
          sendABTasty("BackupEmailStep")
        }).catch(function(err) {
          // console.log('Webhook signup form:', err);
        });
      }
    });
  }

  /* Start mobile navigation */
  const navMobileButton = document.querySelector('.js-mobile-nav-button');
  const navMobileContainer = document.querySelector('.nav__mobile');

  function mobileBackgroundClick() {
    navMobileButton.dispatchEvent(new Event("click"));
  }

  function mobileMenuDisplay(e) {
    e.preventDefault(); 

    if (!navMobileButton.classList.contains('nav__mobile--opened')) {
      sendABTasty("MobileMenuOpen");
      navMobileButton.classList.add('nav__mobile--opened');
      navMobileContainer.classList.add('nav__mobile--active');
      navMobileButton.ariaLabel = window.theme.strings.close_mobile_menu; 
      navMobileContainer.style.height = '0px';
      navMobileContainer.scrollTop = 0;

      document.querySelector('body').style.overflowY = "hidden";
      navMainContent.classList.add('menu_is_hovered'); 
      navMainContent.addEventListener('click', mobileBackgroundClick);

      setTimeout(function () {
        navMobileContainer.style.height = '100vh';
      }, 0);
    } else {
      sendABTasty("MobileMenuClose");
      navMobileContainer.style.height = '0px';

      navMobileContainer.addEventListener('transitionend', function () {
        navMobileButton.classList.remove('nav__mobile--opened');
        navMobileContainer.classList.remove('nav__mobile--active');
        navMobileButton.ariaLabel = window.theme.strings.open_mobile_menu;
        document.querySelector('body').style.overflowY = "scroll";
        navMainContent.classList.remove('menu_is_hovered'); 
        navMainContent.removeEventListener('click', mobileBackgroundClick);
      }, {
        once: true
      });
    }
  }

  navMobileButton.addEventListener('click', function(e) {
    mobileMenuDisplay(e);
  });

  function navSubNavClick(e) {
    e.preventDefault();
    const thisButton = this;
    const thisSubParent = this.parentNode;
    const thisSubContainerL2 = thisSubParent.querySelector('.nav__mobile--l2-sub');
    const thisSubContainerL3 = thisSubParent.querySelector('.nav__mobile--l3-sub');

    if (thisSubContainerL2) {
      if (!thisSubParent.classList.contains('nav__mobile--l2-active')) {
        thisButton.setAttribute('aria-expanded', 'true');
        thisSubParent.classList.add('nav__mobile--l2-active');
        thisSubContainerL2.classList.add('nav__mobile--sub-active');
        thisSubContainerL2.style.height = 'auto';
        var height = thisSubContainerL2.clientHeight + 'px';
        thisSubContainerL2.style.height = '0px';
  
        setTimeout(function () {
          thisSubContainerL2.style.height = height;
        }, 0);
      } else {
        thisSubContainerL2.style.height = '0px';
  
        setTimeout(function () {
          thisButton.setAttribute('aria-expanded', 'false');
          thisSubParent.classList.remove('nav__mobile--l2-active');
          thisSubContainerL2.classList.remove('nav__mobile--sub-active');
        }, 100);

      }
    }

    if (thisSubContainerL3 && thisSubParent.classList.value.includes('nav__mobile--l3')) {
      if(window.outerWidth > 1001){
        const navDesktopSubNavOpened = document.querySelectorAll('.nav__desktop--l2 .nav__mobile--l3-active .js-nav__mobile-link');
        navDesktopSubNavOpened.forEach(element => {
          setTimeout(function () {
            const thisSubParent = element.parentNode;
            thisSubParent.classList.remove('nav__mobile--l3-active');
            const thisSubParentL3 = thisSubParent.querySelector('.nav__mobile--sub-active');
            if (thisSubParentL3) {
              thisSubParentL3.classList.remove('nav__mobile--sub-active');
              thisSubParentL3.style.height = '0px';
            }
          }, 200);
        });
      }

      const thisParentL2 = thisSubParent.parentNode;

      if (!thisSubParent.classList.contains('nav__mobile--l3-active')) {
        thisButton.setAttribute('aria-expanded', 'true');
        thisSubParent.classList.add('nav__mobile--l3-active');
        thisSubContainerL3.classList.add('nav__mobile--sub-active');

        thisParentL2.style.height = 'auto';

        thisSubContainerL3.style.height = 'auto';
        var heightL3 = thisSubContainerL3.clientHeight + 'px';
        thisSubContainerL3.style.height = '0px';
  
        setTimeout(function () {
          thisSubContainerL3.style.height = heightL3; 
        }, 0);
      } else {
        thisSubContainerL3.style.height = '0px';
        thisParentL2.style.height = 'auto';
  
        thisSubContainerL3.addEventListener('transitionend', function () {
          thisButton.setAttribute('aria-expanded', 'false');
          thisSubParent.classList.remove('nav__mobile--l3-active');
          thisSubContainerL3.classList.remove('nav__mobile--sub-active');
        }, {
          once: true
        });
      }
    }
  }

  const navMobileSubNav = document.querySelectorAll('.js-nav__mobile-link');
  navMobileSubNav.forEach(trigger => trigger.addEventListener('click', navSubNavClick));
  /* End mobile navigation */

  try {
    if (localStorage && localStorage.getItem('is_popup_link_clicked') != "yes") {
      $('.site__header--popup').addClass("mr-2");
      $('.site__header--indicator-nav').show();
    }
  } catch (error) {
    // console.log(error)
  }  

  const yotPoBadge = document.querySelector('.js-yotpo-badge'); 
  if( yotPoBadge !== null ){
    const yotPoPostData = {
      "methods": [{
        "method": "badge",
        "params": {}
      }],
      "app_key": yotPoBadge.dataset.key
    };
  
    fetch("https://staticw2.yotpo.com/batch?", {
      method: "POST",
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'Origin': window.location.host
      },
      referrer: window.location.host,
      body: JSON.stringify(yotPoPostData)
    }).then(response => {
      response.json().then(function(response) {
        let result = response[0].result;
        if (!window.location.pathname.includes("cart")) {
          result = result.replace("//staticw2.yotpo.com/assets/badge.png","");
        }
        
        const parsed = document.createRange().createContextualFragment(result);
        
        parsed.querySelector('.y-badge-image').setAttribute("alt", "")
        if (!window.location.pathname.includes("cart")) {
          parsed.querySelector('.y-badge-image').remove();
        }

        let numberReviews = parsed.querySelector('.y-badge-reviews').innerText;
 
        const badgeStars = parsed.querySelector('.y-badge-stars');
        const badgeStarRating = badgeStars.querySelector('.sr-only');

        let starScore = badgeStarRating.innerText;
        starScore = starScore.replace(' star rating','')

        badgeStars.innerHTML = `<div class="review__stars--score" style="--percent: ${parseInt(starScore * 20)}%"></div>`;
        badgeStars.appendChild(badgeStarRating)

        yotPoBadge.innerHTML = '';
        yotPoBadge.appendChild(parsed); 

        // add number of reviews to home/cart custom-reviews
        const numberReviewsText = document.querySelector('.js-yotpo-reviews');
        if (numberReviewsText !== null ){
          
          if (!numberReviews.includes('.')) {
            numberReviews = numberReviews.replace('K','.0K');
          }
          numberReviews = numberReviews.replace('.',',').replace('K','00');
          numberReviewsText.innerText = numberReviews;
        }

      });
    });
  }

  const generateReviewStarsCode = (score, total) => {
    return `
      <div class="review__stars--score" style="--percent: ${Math.round(score / 5 * 100)}%"></div>
      <div class="review__stars--number font-family-gotham text-uppercase ml-1">${numberWithCommas(total)}&nbsp;${total == 1 ? window.theme.strings.reviews_single : window.theme.strings.reviews_plural}</div>
    `
  }

  const fetchYotpoReviews = async (key, ids) => { 
    // kits may have a number of ids for the products it contains
    const idsArray = ids.split(',').map(id => id.trim()); // Split and trim IDs

    const fetchPromises = idsArray.map(async (id) => {
      try {
        const response = await fetch(`https://api.yotpo.com/v1/widget/${key}/products/${id}/reviews.json?per_page=51`, {
          credentials: "omit"
        });
        if (!response.ok) {
          throw new Error(`Failed to fetch ID ${id}: ${response.status}`);
        }
        const data = await response.json();
        return data;
      } catch (error) {
        console.error(`Error fetching ID ${id}:`, error);
        return null;
      }
    });

    const results = await Promise.all(fetchPromises);
    return results; // Return the collected results
  }

  const yotPoStars = document.querySelectorAll('.js-get-stars');
  yotPoStars.forEach(async (element) => {
    let review_stars_code = "";

    if (Shopify.shop == "quad-lock-dev.myshopify.com") {
      // add fake reviews for DEV
      review_stars_code = generateReviewStarsCode(4, 20);
    } else {
      const results = await fetchYotpoReviews(element.dataset.key, element.dataset.pid).then((results) => {
        const stars = {
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
        }

        results.forEach((result) => {
          const distribution = result.response?.bottomline?.star_distribution;
          if (distribution) {
            for (let i = 1; i <= 5; i++) {
              stars[i] = stars[i] + distribution[i];
            }
          }
        })

        let totalReviews = 0;
        let totalScore = 0;

        for (let i = 1; i <= 5; i++) {
          totalReviews += stars[i];
          totalScore += i * stars[i];
        }

        review_stars_code = generateReviewStarsCode(totalScore / totalReviews, totalReviews);
      })
    }

    // put the review stars code in
    element.innerHTML = review_stars_code;

    // attach it to any other places this appears
    const yotPoUpdateStars = document.querySelectorAll(`.js-update-stars[data-pid='${element.dataset.pid}']`);
    if(yotPoUpdateStars != null){
      yotPoUpdateStars.forEach(element => {
        element.innerHTML= review_stars_code; 
      });
    }
  });

  const cart_announcement_popup_link = document.querySelector('.js-cart__announcement-popup');
  if(cart_announcement_popup_link != null){
    cart_announcement_popup_link.addEventListener('click', function(e) {
      e.preventDefault();
      document.querySelector('.site__header--shipping').dispatchEvent(new Event("click"));
      sendGA('Cart', 'Announcement - Show Shipping popup', "(not set)");
    });
  }

  $('.review__stars--collection').on('click', (function(e) {
    e.stopPropagation();
    e.preventDefault();
    let category = null;
    const action = 'YotPo Stars Widget';
    const label = 'Widget clicked';

    if (window.location.pathname.includes('/collections')){
      category = 'Collection';
    }

    if(category === 'Collection'){
      sendGA(category, action, label);  
    }

    location.assign($(this).data('url'));
  }));

  function getStoreName() {
    switch (Shopify.shop) {
      case "quadlockcase-jp.myshopify.com":
        return "ASIA";
      case "quadlockcase-au.myshopify.com":
        return "AU";
      case "quadlockcase-ca.myshopify.com":
        return "CA";
      case "quadlockcase-eu.myshopify.com":
        return "EU";
      case "quadlockcase-uk.myshopify.com":
        return "UK";
      case "quad-lock-dev.myshopify.com":
        return "DEV";
      default:
        return "USA";
    }
  }

  //start IP geolocation
  function insertIpBlocks(country_code, store_name, redirectURL) {
    const location = 'https://' + window.location.hostname + window.location.pathname;
    const productTemplate = document.querySelector('.template-product') || document.querySelector('.suffix-byk');
    const redirectURLutm = redirectURL + '?utm_source=shopify&utm_medium=referral&utm_campaign=geolocation%20block';
    window.georedirect = {};
    window.georedirect.url = redirectURLutm;

    let regionNames = new Intl.DisplayNames([Shopify.locale], {type: 'region'});
    window.georedirect.warning = `${window.theme.strings.ip_does_not_ship_prefix} (${regionNames.of(country_code)}) ${window.theme.strings.ip_does_not_ship_suffix}`
    window.georedirect.button_go_to = `${window.theme.strings.ip_button_go_to.replace("xyz", store_name)}`;
    window.georedirect.button_stay = `${window.theme.strings.ip_button_stay.replace("xyz", getStoreName())}`

    //if the visitor isn't on the right site, show ip bars
    if (location !== redirectURL) {
      window.georedirect.show = true;

      //footer IP Bar
      const ipBar = document.querySelector('.ip_footer');
      if (ipBar !== null && localStorage && localStorage.getItem('is_footer_bar_closed') != "yes" && productTemplate === null) {
        //close button
        ipBar.querySelector('.ip_btn--no').addEventListener('click', function() {
          ipBar.classList.add('fade-out-animation-active'); 
          try {
            localStorage.setItem('is_footer_bar_closed', 'yes');
          } catch (error) {
            console.log("localStorage error");
          }
          document.querySelector('body').classList.remove('showing_ip_footer');
        });
        ipBar.querySelector('.ip_btn--yes').addEventListener('transitionend', function(e) {
          e.stopPropagation();
        });
        ipBar.querySelector('.ip_btn--no').addEventListener('transitionend', function(e) {
          e.stopPropagation();
        });
        ipBar.addEventListener('transitionend', function() {
          ipBar.classList.add('fade-out-animation-complete');

          if (ipCookie !== null) {
            ipCookie.style.bottom = '0px';
          }
        });

        //bar setup
        ipBar.querySelector('.ip_btn--warning').innerText = window.georedirect.warning; 
        ipBar.querySelector('.ip_btn--yes').innerText = window.georedirect.button_go_to;
        ipBar.querySelector('.ip_btn--no').innerText = window.georedirect.button_stay;
        ipBar.querySelector('.ip_btn--yes').setAttribute('href', redirectURLutm);

        //show bar
        ipBar.style.display = 'flex';
        setTimeout(function(){
          try {
            sendGA('Geolocation', 'Footer warning', 'Shown');
          } catch (err) {
            // console.log(err)
          }
        }, 1000);

        const body = document.querySelector('body');
        body.classList.add('showing_ip_footer');
      }
    }
  }

  function showCartShippingMessages() {
    const hasOnlyGiftCards = document.querySelectorAll('.has-only-giftcards');
    const cartShippingMessages = document.querySelectorAll('.js-shipping-message');
    cartShippingMessages.forEach(element => {
      if (hasOnlyGiftCards.length === 0){
        element.classList.remove('d-none');
      } else {
        element.classList.add('d-none');
      } 
    });
  }

  function checkShippingNotices() {
    const hideAnnouncement = document.querySelector('.js-hide-us-cart-announcement');
    if(hideAnnouncement) {
      hideAnnouncement.remove(); 
    }
  }

  function setGeoBlock(country, region) {
    try {
      window.geoblock = {};
      window.geoblock.battery = true;
      window.geoblock.express = true;
      window.geoblock.block_non_usa_products = true;

      if (["AT","BE","HR","CZ","DK","EE","FI","FR","DE","HU","LN","LT","MC","NL","PL","RO","DK","SI","CA","SK","BG","LV"].includes(country)) {
        window.geoblock.battery = false;
      } else if (country == "AU") {
        // by default this will be false
        window.geoblock.battery = ["TAS"].includes(region)
      } else if (country == "SE") {
        // by default this will be false
        window.geoblock.battery = ["I"].includes(region)
      } else if (country == "ES") {
        // by default this will be false
        window.geoblock.battery = ["GC", "IB", "PM", "TF"].includes(region)
      } else if (country == "IT") {
        // by default this will be false
        window.geoblock.battery = ["82", "88", "AG", "CA", "CL", "CT", "EN", "ME", "NU", "OR", "PA", "RG", "SS", "SR", "SD", "TP"].includes(region)
      } else if (country == "PT") {
        // by default this will be false
        window.geoblock.battery = ["PT-20", "PT-30"].includes(region)
      } else if (country == "GR") {
        // by default this will be false
        window.geoblock.battery = ["M", "L", "F", "K"].includes(region)
      } else if (country == "GB") {
        // by default this will be false (eg not Northern Island)
        window.geoblock.battery = ["NIR"].includes(region)
      } else if (country == "US") {
        // by default this will be false (eg not Hawaii)
        window.geoblock.battery = ["AK", "HI"].includes(region)
        window.geoblock.block_non_usa_products = false;
      }

      if(window.geoblock.battery) {
        const dangerousGoods = document.querySelectorAll("[data-dg='true']");
        dangerousGoods.forEach(function(element) {
          element.remove();
        });
        const dangerousGoodsDisclaimer = document.querySelectorAll("[data-dg-disclaimer='true']");
        dangerousGoodsDisclaimer.forEach(function(element) {
          element.classList.remove("d-none");
        });
      }

      if (window.geoblock.block_non_usa_products && window.Shopify.shop == "quadlockcase.myshopify.com") {
        const nonUSAProducts = document.querySelectorAll("[data-block-non-usa-products='true']");
        nonUSAProducts.forEach(function(element) {
          element.remove();
        });
      }
  
      if(country == "XYZ") {
        const hideNoExpress = document.querySelector(".js-dg-no-express");
        if(hideNoExpress) {
          hideNoExpress.remove();
        }
      }
    } catch (error) {
      console.log(error)
      window.geoblock = {};
      window.geoblock.battery = false;
      window.geoblock.express = false;
      window.geoblock.block_non_usa_products = false;
    }
  }

  window.checkLocation = (response) => {
    const country_code = response.country;
    const country_name = response.country_name;
    const region_code = response.region_code;
    setGeoBlock(country_code, region_code);

    const countries_list_asia = ['BN','CN','HK','ID','IN','JP','KH','KR','LA','LK','MO','MY','PH','SG','TH','TW','VN'];
    const countries_list_au = ['AU','CC','CK','CX','FJ','HM','KI','NF','NR','NU','NZ','PG','PN','SB','TK','TL','TO','TV','VU','WS'];
    //canada only has 'CA' so no array
    const countries_list_eu = ['AD','AE','AF','AL','AT','AX','BA','BE','BG','BH','BL','CH','CY','CZ','DE','DK','EE','EG','ES','FI','FO','FR','GF','GL','GP','GR','HR','HU','IE','IS','IT','JO','KW','LI','LT','LU','LV','MC','MD','ME','MF','MK','MQ','MT','NC','NL','NO','OM','PF','PL','PM','PT','QA','RE','RO','RS','RU','SA','SE','SI','SJ','SK','SM','TF','TR','VA','WF','YT'];
    const countries_list_international = ['AG','AI','AM','AO','AR','AW','AZ','BB','BD','BF','BI','BJ','BM','BO','BQ','BR','BS','BT','BW','BZ','CF','CG','CL','CM','CO','CR','CV','DJ','DM','DO','DZ','EC','ER','ET','FK','GA','GD','GE','GH','GM','GN','GQ','GT','GW','GY','HN','HT','IL','JM','KE','KG','KM','KN','KY','KZ','LC','LS','LY','MA','MG','ML','MN','MR','MS','MU','MV','MW','MX','MZ','NA','NE','NG','NI','NP','PA','PE','PK','PS','PY','RW','SC','SH','SN','SO','SR','ST','SV','SZ','TC','TD','TG','TJ','TM','TN','TT','TZ','UA','UG','UY','UZ','VC','VE','VG','YE','ZA','ZM'];
    const countries_list_uk = ['GB','GG','GI','IM','JE'];
    const countries_list_us = ['AS','FM','GU','MH','MP','PR','PW','US','VI'];
    
    if (countries_list_us.includes(country_code)) {
      insertIpBlocks(country_code, 'US', 'https://www.quadlockcase.com'+ window.location.pathname);
      addKlaviyoSignUpCode("US", country_code);
    }
    else if (countries_list_international.includes(country_code)) {
      insertIpBlocks(country_code, 'US', 'https://www.quadlockcase.com'+ window.location.pathname);
      addKlaviyoSignUpCode("US", country_code);
    }
    else if (countries_list_au.includes(country_code)) {
      insertIpBlocks(country_code, 'AU', 'https://www.quadlockcase.com.au'+ window.location.pathname);
      addKlaviyoSignUpCode("AU", country_code);
    }
    else if (countries_list_asia.includes(country_code)) {
      insertIpBlocks(country_code, 'Asia', 'https://www.quadlockcase.asia'+ window.location.pathname);
      addKlaviyoSignUpCode("ASIA", country_code);
    }
    else if (country_code == 'CA') {
      insertIpBlocks(country_code, 'CA', 'https://www.quadlockcase.ca'+ window.location.pathname);
      addKlaviyoSignUpCode("CA", country_code);
    }
    //EU countries that show cookie message and IP blocks
    else if (countries_list_eu.includes(country_code)) {
      insertIpBlocks(country_code, 'EU', 'https://www.quadlockcase.eu'+ window.location.pathname);
      addKlaviyoSignUpCode("EU", country_code);
    }
    else if (countries_list_uk.includes(country_code)) {
      insertIpBlocks(country_code, 'UK', 'https://www.quadlockcase.co.uk'+ window.location.pathname);
      addKlaviyoSignUpCode("UK", country_code);
    }

    if (Shopify.shop == "quad-lock-dev.myshopify.com") {
      insertIpBlocks(country_code, 'AU', 'https://www.quadlockcase.com.au'+ window.location.pathname);
    }

    if (Shopify.shop == "quadlockcase.myshopify.com"){
      if (country_code == "US") {
        showCartShippingMessages();
        checkShippingNotices()
      }
      //otherwise they are hidden
    } else if (Shopify.shop == "quadlockcase-au.myshopify.com"){
      if (country_code == "AU") {
        showCartShippingMessages()
      }
      //otherwise they are hidden
    } else {
      showCartShippingMessages()
    }
  }

  function fetchGeolocation() {
    // Geotargetly embed
    if (Shopify.shop == 'quadlockcase.myshopify.com') {
      var geotargetlyId = "-M-lJCJMrNTs2nEFP3Oo";
    } else if (Shopify.shop == 'quadlockcase-jp.myshopify.com') { 
      var geotargetlyId = "-M-mEmVbyvi5mfM33oTR";
    } else if (Shopify.shop == 'quadlockcase-au.myshopify.com') { 
      var geotargetlyId = "-M-mE0PqQ3Vm7tzeC8Hc";
    } else if (Shopify.shop == 'quadlockcase-ca.myshopify.com') { 
      var geotargetlyId = "-M-mF1CZIurskePECKGd";
    } else if (Shopify.shop == 'quadlockcase-eu.myshopify.com') { 
      var geotargetlyId = "-M-mF9MIeH0gqsQJlWQJ";
    } else if (Shopify.shop == 'quadlockcase-uk.myshopify.com') {
      var geotargetlyId = "-M-mFMYZDx2MW9Fe6DwV";
    } else if (window.location.origin == "https://localhost:8080") {
      var geotargetlyId = "-NCw8BJ81808h_HgqlfZ";
    } else { //dev
      var geotargetlyId = "-M-l8TBNytnQiAWcutgu";
    }

    (function(g,e,o,t,a,r,ge,tl,y){
    t=g.getElementsByTagName(e)[0];y=g.createElement(e);y.async=true;
    y.src='https://g1386590346.co/gl?id='+geotargetlyId+'&refurl='+g.referrer+'&winurl='+encodeURIComponent(window.location);
    t.parentNode.insertBefore(y,t);
    })(document,'script');
  }

  try {
    let geoLocationData = JSON.parse(localStorage.getItem('geolocationData'));
    if (geoLocationData !== null) {
      checkLocation(geoLocationData);
    } else {
      fetchGeolocation();
    }
  } catch (error) {
    console.log("localStorage error");
    fetchGeolocation();
  }
  
  //end IP geolocation
  
  //external link tracking
  externalLinks = document.querySelectorAll('.product__info a, .article__contents a, .page__content a');
  externalLinks.forEach(link => {
    if (link.host !== window.location.host && link.href !== "javascript:void(0)") {
      const actionText = link.innerText === "" ? link.href : link.innerText; 
      link.setAttribute('target', '_blank');
      link.addEventListener('click', (e) => {
        sendGA('External link', actionText, link.href)
      });
    }
  });

    // AB goal tracking
    // to use:
    // add "ab-event" as a class on the a or button
    // add data-tracking="TeaserGet10Off" too
    // here TeaserGet10Off is the name of the goal
    abEvents = document.querySelectorAll('.ab-event');

    abEvents.forEach(element => {
      element.addEventListener('click', (e) => {
        currentTarget = e.currentTarget;
        
        const name = currentTarget.dataset.tracking !== undefined ? currentTarget.dataset.tracking : null;
        const label = currentTarget.dataset.label !== undefined ? currentTarget.dataset.label : null;

        if(label !== null && name !== null) {
          sendABTastyDetails(name, label)
        } else if(name !== null){
          sendABTasty(name);
        }
      });
    });
});

function geotargetly_loaded(){
  const location = {
    country: geotargetly_country_code(),
    country_name: geotargetly_country_name(),
    region_code: geotargetly_region_code(),
    ip: geotargetly_ip(),
  }

  try {
    localStorage.setItem('geolocationData', JSON.stringify(location));
  } catch (error) {
    console.log("localStorage error");
  }

  checkLocation(location);
}

window.addEventListener("klaviyoForms", function(e) {
  if (e.detail.type == 'embedOpen') {
    try {
      localStorage.setItem('is_klaviyo_loaded', 'yes');
    } catch (error) {
      console.log("localStorage error");
    }

    const desktopPopupLink = document.querySelector('.site__header--popup');
    if (desktopPopupLink) {
      desktopPopupLink.classList.add('d-block');
    }

    const mobilePopupLink = document.querySelector('.js-mobile-popup-link');
    if (mobilePopupLink) {
      mobilePopupLink.classList.remove('d-none');
    }
  }

  if (e.detail.type == 'submit') {
    try {
      localStorage.setItem('is_popup_link_clicked', 'yes');
      localStorage.setItem('is_klaviyo_submitted', 'yes');
      const popup_teaser = document.querySelector('.form__teaser');
      if(popup_teaser) {
        popup_teaser.classList.remove('is--active')
      }
    } catch (error) {
      console.log("localStorage error");
    }
    
    const navPopupIndicatorNavs = document.querySelectorAll('.site__header--indicator-nav');
    navPopupIndicatorNavs.forEach(element => element.classList.add('d-none'));

    try {	
      localStorage.setItem("customer", JSON.stringify(window.customer))
    } catch (error) {	
      console.log("localStorage error");	
    }

    Shopify.analytics.publish("custom_lead", {
      content_name: 'Newsletter popup'
    });

    sendGA("Klaviyo", "Email submitted", "null");
    sendABTasty("KlaviyoSubmitted")
  }

  if (e.detail.type == 'stepSubmit') {
    sendGA("Klaviyo", `Form step submitted: ${e.detail.metaData.$step_name}`, "null");
    sendGA("Klaviyo", `Form source submitted: ${e.detail.metaData.$source}`, "null");

    if (e.detail.metaData.$step_name == "Email Opt-In") {
      sendABTasty("KlaviyoEmailStep")
    }   
  }

  if (e.detail.type == 'close') {
    sendABTasty("KlaviyoClose")
    try {
      if (!localStorage.getItem('is_klaviyo_submitted')) {
        localStorage.setItem('klaviyoPopup', 'yes');
        const popup_teaser = document.querySelector('.form__teaser');
        if(popup_teaser) {
          popup_teaser.classList.add('is--active')
        }
      }
    } catch (error) {
      console.log("localStorage error");
    }
  }
});
